import {useSelector} from 'react-redux';

export default () =>
	useSelector(({dashboardContext}) => {
		const entities = dashboardContext.entities;
		const filteredEntities = entities.filter(({engagements}) => engagements.length > 0);
		if (filteredEntities.length === 0) return [];
		return filteredEntities;
	});
